export const minimumCarbonAmountInTonnes = 0.001;

export const currencyOptions = [
  { label: 'EUR', value: 'EUR' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NOK', value: 'NOK' },
];

export const currencies = ['EUR', 'USD', 'GBP', 'NOK'];

// 2 years as in the case of the GDPR
export const MAX_AGE_FOR_POPUP = 6.307e7;
